<head>

<script src="https://unpkg.com/vue"></script>
<script src="https://unpkg.com/vue-cal"></script>
<link href="https://unpkg.com/vue-cal/dist/vuecal.css" rel="stylesheet">
</head>
<template>
  <fieldset>
    <legend style="width: 160px">Dados Paciente</legend>
    <div class="row">
      <div style="display: flex; flex-direction: column; max-width: 250px; max-height: 230px">
        <img class="rounded" alt="" id="imgFoto" style="flex: 1; object-fit: cover; max-width: 250px; max-height: 210px" />
      </div>
      <div class="col">
        <div class="row">
          <div class="col-md-12" style="padding: 0px 10px">
            <label for="nome">Nome </label>
            <input type="text" class="form-control form-input-component" v-model="dadosMilitarCopy.nome" id="nome" disabled />
          </div>
          <div class="col-md-4" style="padding: 0px 10px">
            <label for="rgCivil">RG Militar</label>
            <input type="text" class="form-control form-input-component" v-model="responseSicad.rgMilitar" id="rgMilitar" disabled />
          </div>
          <div class="col-md-8" style="padding: 0px 10px">
            <label for="cpf">CPF</label>
            <input type="text" class="form-control form-input-component" v-model="dadosMilitarCopy.cpf" v-mask="'###.###.###-##'" ref="cpf" id="cpf" disabled />
          </div>
          <div class="col-md-5" style="padding: 0px 10px">
            <label for="cpf">Posto Graduação</label>
            <input type="text" class="form-control form-input-component" v-model="responseSicad.posto.nome" ref="posto" id="posto" disabled />
          </div>
          <div class="col-md-7" style="padding: 0px 10px">
            <label for="cpf">Unidade</label>
            <input type="text" class="form-control form-input-component" v-model="responseSicad.lotacao.sigla" ref="unidade" id="unidade" disabled />
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import _ from 'lodash';
import semFoto from '../../assets/paciente.jpeg';
import { loadDocumentFileWs } from '@/utils/filews';
import { convertBase64ToBlob, imgToBase64 } from '@/utils/servicos-utils';
import { getUserByCpf } from '@/config/servicos-utils';
export default {
  name: 'PageDadosMilitar',
  components: {},
  props: {
    dadosMilitar: Object,
  },
  setup() {
    return {
      dadosMilitarCopy: Object,
      responseSicad: { posto: { nome: '' }, lotacao: { sigla: '' } },
    };
  },

  data() {
    return {};
  },
  validations() {
    return {};
  },
  methods: {
    async onInit() {
      if (this.dadosMilitar) {
        this.dadosMilitarCopy = _.clone(this.dadosMilitar);
        await this.patchFormSicad(this.dadosMilitar.cpf);
        await this.carregarImg(this.dadosMilitarCopy.idAnexoFileImg);
        let dadosMilitarNovo = _.clone(this.dadosMilitar);
        if (this.responseSicad.posto) {
          dadosMilitarNovo.posto = this.responseSicad.posto;
        }
        if (this.responseSicad.lotacao) {
          dadosMilitarNovo.lotacao = this.responseSicad.lotacao;
        } else {
          this.responseSicad.lotacao = { sigla: '' };
        }
        this.$emit('update:dadosMilitar', dadosMilitarNovo);
      }
    },
    async carregarImg(idImg) {
      if (idImg) {
        await loadDocumentFileWs(idImg).then(async (img) => {
          document.getElementById('imgFoto').src = await imgToBase64(img);
        });
      } else if (this.responseSicad.imagem) {
        let imgBlob = convertBase64ToBlob('data:image/jpg;base64,' + this.responseSicad.imagem);
        document.getElementById('imgFoto').src = await imgToBase64(imgBlob);
      } else {
        document.getElementById('imgFoto').src = semFoto;
      }
    },
    async patchFormSicad(cpf) {
      await getUserByCpf(cpf).then((r) => {
        this.responseSicad = r.data;
      });
    },
  },

  created() {
    this.onInit();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}
</style>
